import { deepGet } from '../shared/helper'
import { getIDPSessionState } from './helper'

export default class IDPUser {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      genderId: 1,
      email: null,
      login: null,
      title: null,
      firstname: null,
      lastname: null,
      isActive: false,
      signInCount: 0,
      lastSignInAt: null,
      clientsData: [],
      createdAt: null,
      updatedAt: null,
      accountCount: 0,

      idpSessionState: 0,
    }
  }

  set(data) {
    this.setIDPSessionState(data)
    this.setAccountCount(data)
    Object.assign(this, data)
  }

  // Determine session state by lastSignInAt
  setIDPSessionState(data) {

    if (!data.lastActivity) {
      // Bail out if not logged in
      data.idpSessionState = 4
      return
    }

    data.idpSessionState = getIDPSessionState(data.lastActivity)

  }

  setAccountCount(data) {
    data.accountCount = deepGet(data, 'clientsData.mail2many.accounts.length') || 0
  }

  getJSON() {
    return {
      id: this.id,
      genderId: this.genderId,
      email: this.email,
      login: this.login,
      title: this.title,
      firstname: this.firstname,
      lastname: this.lastname,
      isActive: this.isActive,
      signInCount: this.signInCount,
      lastSignInAt: this.lastSignInAt,
      clientsData: this.clientsData,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/idpUser/model.js